import { IconsProps } from './IconsProps';

const Facebook = ({
  className = '',
  viewBox = '0 0 40 40',
  width = 40,
  height = 40,
  onClick,
  svgFill = 'currentColor',
}: IconsProps) => {
  return (
    <svg
      className={className}
      viewBox={viewBox}
      width={`${width}px`}
      height={`${height}px`}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      onClick={onClick}
      fill={svgFill}
      aria-label="Facebook"
    >
      <g clipPath="url(#clip0_940_80)">
        <path d="M20 40C8.97254 40 0 31.0291 0 20C0 8.97087 8.97254 0 20 0C31.0275 0 40 8.97254 40 20C40 31.0275 31.0275 40 20 40ZM20 2.00317C10.076 2.00317 2.00317 10.076 2.00317 20C2.00317 29.924 10.076 37.9968 20 37.9968C29.924 37.9968 37.9968 29.924 37.9968 20C37.9968 10.076 29.924 2.00317 20 2.00317Z" />
        <path d="M16.7398 31.9272L21.5207 31.9522C21.5207 31.9522 21.5541 25.3534 21.5825 20L25.1314 20.0183L25.5922 15.2391L21.7928 15.2191L21.8028 13.3077C21.8078 12.3762 22.4288 12.1626 22.8645 12.1642C23.3019 12.1659 25.5471 12.1776 25.5471 12.1776L25.5671 8.08109L21.8746 8.04771C17.7748 8.02767 16.8283 11.0775 16.8183 13.0323L16.8066 15.1924L14.4362 15.1807L14.4111 19.9616L16.8016 19.9733C16.7732 25.3902 16.7398 31.9255 16.7398 31.9255V31.9272Z" />
      </g>
      <defs>
        <clipPath id="clip0_940_80">
          <rect width="40" height="40" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Facebook;
